<template>
  <div class="project">
    <div class="project-title">
      <h2 class="main_title">真实项目 从零到一百</h2>
      <h3 class="ind_subtitle">
        单体项目到微服务，到分布式解决方案，到ServiceMesh(服务网格)
      </h3>
    </div>
    <div class="project-content">
      <div class="content-left">
        <ul>
          <li
            v-for="(item, index) in projectList"
            :key="index"
            :class="{ active: projectIndex === index }"
            @click="changeProject(index)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
      <div class="content-right" style="display: block" data-content-index="1">
        <section data-section-index="1">
          <p class="thumbtack">01</p>
          <article>
            <img src="~@/assets/project/project-2.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="2" style="display: none">
          <p class="thumbtack">02</p>
          <article>
            <h4>项目介绍</h4>
            <img src="~@/assets/project/project-4.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="3" style="display: none">
          <p class="thumbtack">03</p>
          <article>
            <h4>项目架构图</h4>
            <img src="~@/assets/project/project-6.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="4" style="display: none">
          <p class="thumbtack">04</p>
          <article>
            <h4>代码展示</h4>
            <img src="~@/assets/project/project-8.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="5" style="display: none">
          <p class="thumbtack">05</p>
          <article>
            <h4>授课安排</h4>
            <img src="~@/assets/project/project-11.jpg" alt="" />
          </article>
        </section>
        <ul class="page">
          <li data-page="1" class="active">01</li>
          <li data-page="2">02</li>
          <li data-page="3">03</li>
          <li data-page="4">04</li>
          <li data-page="5">05</li>
        </ul>
      </div>
      <div class="content-right" style="display: none" data-content-index="2">
        <section data-section-index="1">
          <p class="thumbtack">01</p>
          <article>
            <h4>项目界面一览</h4>
            <img src="~@/assets/project/project-3.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="2" style="display: none">
          <p class="thumbtack">02</p>
          <article>
            <h4>项目概述</h4>
            <img src="~@/assets/project/project-5.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="3" style="display: none">
          <p class="thumbtack">03</p>
          <article>
            <h4>项目架构图</h4>
            <img src="~@/assets/project/project-7.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="4" style="display: none">
          <p class="thumbtack">04</p>
          <article>
            <h4>代码展示</h4>
            <img src="~@/assets/project/project-9.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="5" style="display: none">
          <p class="thumbtack">05</p>
          <article>
            <h4>授课安排</h4>
            <img src="~@/assets/project/project-10.jpg" alt="" />
          </article>
        </section>
        <ul class="page">
          <li data-page="1" class="active">01</li>
          <li data-page="2">02</li>
          <li data-page="3">03</li>
          <li data-page="4">04</li>
          <li data-page="5">05</li>
        </ul>
      </div>
      <div class="content-right" style="display: none" data-content-index="3">
        <section data-section-index="1">
          <p class="thumbtack">01</p>
          <article>
            <h4>项目介绍</h4>
            <img src="~@/assets/project/project-12.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="2" style="display: none">
          <p class="thumbtack">02</p>
          <article>
            <h4>项目架构</h4>
            <img src="~@/assets/project/project-13.jpg" alt="" />
          </article>
        </section>
        <ul class="page">
          <li data-page="1" class="active">01</li>
          <li data-page="2">02</li>
        </ul>
      </div>
      <div class="content-right" style="display: none" data-content-index="4">
        <section data-section-index="1">
          <p class="thumbtack">01</p>
          <article>
            <h4>项目概述</h4>
            <img src="~@/assets/project/project-14.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="2" style="display: none">
          <p class="thumbtack">02</p>
          <article>
            <h4>项目架构</h4>
            <img src="~@/assets/project/project-15.jpg" alt="" />
          </article>
        </section>
        <section data-section-index="3" style="display: none">
          <p class="thumbtack">03</p>
          <article>
            <h4>授课安排</h4>
            <img src="~@/assets/project/project-16.jpg" alt="" />
          </article>
        </section>
        <ul class="page">
          <li data-page="1" class="active">01</li>
          <li data-page="2">02</li>
          <li data-page="3">03</li>
        </ul>
      </div>
    </div>
    <a
      target="_blank"
      href="https://www26c1.53kf.com/webCompany.php?kf_sign=DI1ODMTU5OczMjExODg3NTY0OTU2MDEyNzIyMDgxNTU=&arg=10208155&style=1&kflist=off&kf=2772871435%40qq.com%2C1901399166%40qq.com%2C2713198802%40qq.com%2C1852303966%40qq.com%2C641302463%40qq.com%2C1815613782%40qq.com%2C1120465273%40qq.com%2C2102826435%40qq.com%2C2817700763%40qq.com%2C2563613419%40qq.com%2C2687033397%40qq.com%2C1669964656%40qq.com&zdkf_type=1&lnk_overflow=0&language=zh-cn&charset=GBK&username=&userinfo=&introurl=&lyurl=&lytype=0&copartner=&referer=http%3A%2F%2Fmashibing.com%2F&keyword=&brief=&logo=&question=&uid=2d242da47aadaebb8576fe6bc8e5fddc&guest_id=&tfrom=2&timeStamp=1598258738835&ucust_id="
    >
      <button>点击了解更多项目</button></a
    >
  </div>
</template>

<script>
import $ from '../../mcaStatic/js/jquery.min.js'
export default {
  data () {
    return {
      projectIndex: 0,
      itemIndex: 0,
      projectList: [
        {
          title: '飞滴出行项目白皮书第三版-v1.0'
        },
        {
          title: '咚宝商城项目白皮书第一版'
        },
        // {
        //   title: '基于节目的个性化实时推荐系统白皮书'
        // },
        {
          title: '基于Flink的城市交通实时监控平台_白皮书1.0版'
        },
        {
          title: '英雄传说多人在线网游项目白皮书第二版'
        },
      ]
    }
  },
  mounted () {
    $('[data-page]').click(function () {
      const index = +$(this).attr('data-page')
      $(this).addClass('active').siblings().removeClass('active')
      $(this).closest('[data-content-index]').find('[data-section-index]').hide()
      $(this).closest('[data-content-index]').find('[data-section-index]').eq(index - 1).show()
    })
  },
  methods: {
    changeProject (index) {
      this.projectIndex = index
      $(`[data-content-index]`).hide()
      $(`[data-content-index="${index + 1}"]`).show()
    }
  }
}
</script>

<style lang="scss" scoped>
.project {
  width: 1000px;
  margin: 0 auto;
  text-align: center;
  &-title {
    background-color: #f8fafc;
    margin: 0 auto;
    display: inline-block;
    padding: 12px 40px;
    margin-top: 60px;
    margin-bottom: 60px;
    h2 {
      font-size: 24px;
    }
    h3 {
      line-height: 34px;
    }
  }
  &-content {
    display: flex;
    border-radius: 12px 0 0 12px;
    border: 3px solid #d6d0fd;
    border-left: 0;
    .content-left {
      text-align: left;
      width: 210px;
      position: relative;
      flex-shrink: 0;
      &::before {
        content: '';
        display: block;
        width: 100%;
        border: 3px solid #6667d3;
        height: 100%;
        position: absolute;
        left: -24px;
        top: -24px;
        z-index: 1;
        border-radius: 12px;
      }
      ul {
        position: relative;
        z-index: 2;
        background: linear-gradient(to bottom, #6667d3, #6c5cea);
        padding: 24px 0 24px 24px;
        border-radius: 12px;
        transform: scale(1.01);
        li {
          color: #fff;
          padding: 12px 24px 12px 12px;
          border-radius: 6px 0 0 6px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          &.active {
            background-color: #fff;
            color: #6155c6;
          }
        }
      }
    }
    .content-right {
      position: relative;
      flex-grow: 1;
      display: none;
      section {
        display: flex;
        padding: 48px 60px 0;
        position: relative;
        .thumbtack {
          position: absolute;
          display: inline-block;
          font-size: 32px;
          font-weight: 600;
          color: #d4d1fb;
          padding: 12px 20px;
          right: 24px;
          top: 24px;
          &::before {
            content: '';
            background-color: #fff;
            border-left: 1px solid #8662aa;
            position: absolute;
            width: 10px;
            height: 43px;
            transform: rotate(41deg);
            top: 10px;
            left: 49px;
          }
        }
        article {
          flex-grow: 1;
          flex-shrink: 1;
          text-align: left;
          h4 {
            color: #6155c6;
            font-size: 24px;
            font-weight: 500;
            margin-bottom: 24px;
          }
          img {
            width: auto;
            max-width: 100%;
            max-height: 285px;
          }
        }
      }
      .page {
        position: absolute;
        right: -31px;
        top: 50%;
        transform: translateY(-50%);
        li {
          cursor: pointer;
          color: #fff;
          font-size: 16px;
          margin-bottom: 6px;
          padding: 8px 6px;
          border-radius: 0 12px 12px 0;
          background: linear-gradient(to right, #d9d7ea, #bcb5f2);
          &.active {
            background: linear-gradient(to right, #6658d3, #705ff6);
          }
        }
      }
    }
  }
  button {
    margin: 32px auto;
    background: linear-gradient(to left, #6667d3, #6c5cea);
    color: #fff;
    outline: none;
    padding: 6px 32px;
    border-radius: 20px;
    font-size: 16px;
    box-shadow: 0 4px 0 1px #ebe8ff;
  }
}
</style>